export async function readContextChatStream (response: Response, onDelta: (text: string) => void): Promise<Record<string, unknown>> {
  if (!response.body) throw new Error('O navegador não conseguiu receber a resposta da assistente.')
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let completed: Record<string, unknown> | null = null

  const handleBlock = (block: string): void => {
    const lines = block.split(/\r?\n/)
    const event = lines.find(line => line.startsWith('event:'))?.slice(6).trim()
    const raw = lines.filter(line => line.startsWith('data:')).map(line => line.slice(5).trim()).join('\n')
    if (!raw) return
    const data: unknown = JSON.parse(raw)
    if (!data || typeof data !== 'object' || Array.isArray(data)) return
    if (event === 'delta' && 'text' in data && typeof data.text === 'string') onDelta(data.text)
    if (event === 'done') completed = Object.fromEntries(Object.entries(data))
    if (event === 'error') throw new Error('message' in data && typeof data.message === 'string' ? data.message : 'Não consegui responder agora.')
  }

  try {
    while (true) {
      const { value, done } = await reader.read()
      buffer += decoder.decode(value, { stream: !done })
      const blocks = buffer.split(/\r?\n\r?\n/)
      buffer = blocks.pop() ?? ''
      for (const block of blocks) {
        handleBlock(block)
        if (completed) return completed
      }
      if (done) break
    }
    if (buffer.trim()) handleBlock(buffer)
    if (!completed) throw new Error('A resposta foi interrompida. Tente novamente.')
    return completed
  } finally {
    void reader.cancel().catch(() => {})
    reader.releaseLock()
  }
}
